window.addEventListener('DOMContentLoaded', function () {
	const techGroups = document.querySelectorAll('[data-tech-group-first]');
	const techTabContainer = document.querySelector('.tpt-technology__list-items');
	const techModalContent = document.querySelector('#tpt-modal-alltech .tpt-alltech-modal');

	techGroups.forEach((techGroup) => {
		var groupId = techGroup.getAttribute('data-tech-group-id');
		var groupLabel = techGroup.getAttribute('data-tech-group-label');
		var tabEl = `<tpt-tech-tab class="tpt-tech-tab__item" data-tech-group-target="tpt-tech-id-${groupId}"><span>${groupLabel}</span></tpt-tech-tab>`;

		techTabContainer.insertAdjacentHTML('beforeend', tabEl);
	});

	/**
	 * Create accordion tech item in modal All tech
	 */

	techGroups.forEach((techGroup) => {
		const techHeading = techGroup.getAttribute('data-tech-group-label');
		var techData = '';
		const groupId = techGroup.getAttribute('data-tech-group-id');
		const groupItems = document.querySelectorAll(`[data-tech-group-id="${groupId}"] .tpt-technology__item-learn--more`);

		groupItems.forEach((item) => {
			const itemName = item.getAttribute('data-tech-item-label');
			const itemModalTarget = item.getAttribute('data-modal-target');

			const itemLinkModal = `
                <div class="tpt-technology__item-container">
                    <tpt-open-modal class="tpt-technology__item-modal--detail" role="button" tabindex="0" data-modal-target="${itemModalTarget}" aria-haspopup="dialog" aria-label="Learn More" aria-controls="tpt-tech-detail__popup-tech_item_73JnWM" aria-expanded="false" data-tech-item-label="OutDry™ Extreme Eco">
                        ${itemName}
                    </tpt-open-modal>
                </div>
            `;

			techData = techData + itemLinkModal;
		});

		const accordionTech = `
            <tpt-accordion-tech>
                <div class="tpt-accordion-tech__heading">
                    ${techHeading}
                    <svg class="svgicon">
                        <use href="#expand_more"></use>
                    </svg>
                </div>

                <div class="tpt-accordion-tech__data">${techData}</div>
            </tpt-accordion-tech>
        `;

		techModalContent.insertAdjacentHTML('beforeend', accordionTech);
	});

	/**
	 * Create tab all tech in tech modal
	 */

	const accordionData = document.querySelectorAll('tpt-accordion-tech .tpt-accordion-tech__data');
	var allTechData = '';

	accordionData.forEach((data) => {
		allTechData = allTechData + data.innerHTML;
	});

	const accordionAllTech = `
	    <tpt-accordion-tech class="active">
	        <div class="tpt-accordion-tech__heading">
	            ${window.allTextLabel}
	            <svg class="svgicon">
	                <use href="#expand_more"></use>
	            </svg>
	        </div>

	        <div class="tpt-accordion-tech__data">${allTechData}</div>
	    </tpt-accordion-tech>
	`;

	techModalContent.insertAdjacentHTML('afterbegin', accordionAllTech);
});

/**
 * Click tab to scroll tech group
 */
if (!customElements.get('tpt-tech-tab')) {
	customElements.define(
		'tpt-tech-tab',
		class TptTechTabs extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.scrollToGroupTech.bind(this));
			}

			scrollToGroupTech() {
				const techGroupId = this.getAttribute('data-tech-group-target');
				const techGroupOffset = document.getElementById(techGroupId).offsetTop;
				let headerStickyValue = 100;

				if (document.querySelector('[data-header-sticky="true"]')) {
					headerStickyValue = 120;
				}

				window.scroll({
					top: techGroupOffset - headerStickyValue,
					left: 0,
					behavior: 'smooth',
				});

				this.tabActive();
			}

			tabActive() {
				const tabs = document.querySelectorAll('tpt-tech-tab');

				tabs.forEach((tab) => {
					tab.classList.remove('active-item');
				});

				this.classList.add('active-item');
			}
		}
	);
}

/**
 * tpt-accordion-tech
 */
if (!customElements.get('tpt-accordion-tech')) {
	customElements.define(
		'tpt-accordion-tech',
		class TptAccordionTech extends HTMLElement {
			constructor() {
				super();

				const accordionHeading = this.querySelector('.tpt-accordion-tech__heading');
				accordionHeading.addEventListener('click', this.toggleAccordion);
			}

			toggleAccordion() {
				this.closest('tpt-accordion-tech').classList.toggle('active');
			}

			tabActive() {
				const tabs = document.querySelectorAll('tpt-tech-tab');

				tabs.forEach((tab) => {
					tab.classList.remove('active');
				});

				this.classList.add('active');
			}
		}
	);
}
